import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Image } from "antd";
import { styled } from "styled-components";
export const ImageViewer = ({ url, width, handleDelete }) => {
  const defaultWidth = 130;
  return (
    <div
      style={{
        width: width || defaultWidth,
        height: width || defaultWidth,
        borderRadius: 10,
        overflow: "hidden",
        border: "1px solid #ccc",
        position: "relative",
      }}
    >
      <Image
        height="100%"
        width="100%"
        style={{ objectFit: "cover" }}
        src={url}
      />
      <IconButton
        onClick={() => handleDelete(url)}
        sx={{
          top: 0,
          right: 0,
          position: "absolute",
        }}
      >
        <Delete fontSize="small" />
      </IconButton>
    </div>
  );
};

export const ImageWrapper = ({ images, handleDelete }) => {
  if (images?.length > 0)
    return (
      <ImgWrapper className="flexNullCenter gap20">
        {images.map((val) => (
          <ImageViewer url={val} key={val} handleDelete={handleDelete} />
        ))}
      </ImgWrapper>
    );
};

const ImgWrapper = styled.div``;
